import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as irActions from '../../../redux/actions/irSearch';
import * as docketsConstants from '../../../constants/docketsConstants';


class ToolbarButtons extends Component {
  onPopupClick = (name, download_option) => {
    const { case_uuid, dockets } = this.props;

    //grab all the shown docket nums
    const docketNums = dockets.entries.reduce((accum, next) => {
      if (next.meta && next.meta.docket_no && next.meta.docket_seq) {
        accum.push(next.meta.docket_seq);
      }
      return accum;
    }, []);

    const params = {
      case_uuid,
      docket_numbers: docketNums,
    };

    if (download_option) {
      params.download_option = download_option;
    }

    this.props.dispatch(irActions.getDocketParts(params));

    this.props.onPopupClick({
      name,
      show: true,
      data: params,
    });

    // do we need this here?
    this.props.dispatch({
      type: docketsConstants.UPDATE_DOCKETS_PARTS,
      docketParts: {},
    });
  }

  render() {
    const { toggleHeader } = this.props;

    return (
      <div id="docket-toolbar-buttons" className="right menu">
        <a className="item "
           onClick={toggleHeader}
           title="Toggle Docket Header Display">
          <span className="expand icon" /> Header
        </a>

        <div className="ui delayed dropdown item">
          <span className="printer icon" /> Print
          <div className="menu">
            <div className="item"
                 title="Prints Docket Sheet and Header (if visible) "
                 onClick={window.print_preview}>
              <span className="text page icon" /> Docket Sheet
            </div>
            <div className="item"
                 title="Opens bulk docket download and combine form"
                 onClick={this.onPopupClick.bind(null, 'PrintAllPdfInRangePopup', 0)}>
              <span className="pdf icon" /> All PDFs in range
            </div>
          </div>
        </div>
        <div className="ui delayed dropdown item " id="docket-download-menu">
          <span className="download icon" /> Download
          <div className="menu">
            <div className="item" onClick={this.onPopupClick.bind(null, 'DownloadZipAllPdfsRangePopup', 1)}>
              <span className="zip icon" /> ZIP all PDFs in range
            </div>
            <div className="item" onClick={this.onPopupClick.bind(null, 'DownloadZipWithSubpartsPopup', 1)}>
              <span className="zip icon" /> ZIP with subparts combined
            </div>
            <div className="item" onClick={this.onPopupClick.bind(null, 'DownloadCombineAllPdfInRangePopup', 1)}>
              <span className="pdf icon" /> Combine all PDFs in range
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ToolbarButtons.propTypes = {
  dockets: PropTypes.object.isRequired,
  case_uuid: PropTypes.string.isRequired,
  onPopupClick: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  toggleHeader: PropTypes.func.isRequired,
};

export default ToolbarButtons;



/** WEBPACK FOOTER **
 ** ./src/components/case/docket/ToolbarButtons.jsx
 **/